import type { DocNode } from '@atlaskit/adf-schema/doc';

const hasKey = <K extends string>(obj: object, key: K): obj is Record<K, unknown> => key in obj;

const collectText = (node: unknown): string => {
	if (!node || typeof node !== 'object') {
		return '';
	}

	const ownText = hasKey(node, 'text') && typeof node.text === 'string' ? node.text : '';

	const childrenText =
		hasKey(node, 'content') && Array.isArray(node.content)
			? node.content.map(collectText).join(' ')
			: '';

	return [ownText, childrenText].filter(Boolean).join(' ').trim();
};

export const extractTextFromAdfDoc = (doc: DocNode | null | undefined): string => {
	if (!doc) {
		return '';
	}
	return collectText(doc).replace(/\s+/g, ' ').trim();
};
